import FeatureHistoryCardContent from './FeatureHistoryCardContent'

export default FeatureHistoryCardContent
